import { render, staticRenderFns } from "./BlockTranslationContent.vue?vue&type=template&id=8d075b56&"
import script from "./BlockTranslationContent.vue?vue&type=script&lang=ts&"
export * from "./BlockTranslationContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports